import React, { useEffect, useState } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";

const OtsDifficultyLevelCircularProgress = ({ data }) => {
  const [currentToughness, setCurrentToughnhess] = useState(data[0].Toughness);

  const handleChangeSubject = (event) => {
    setCurrentToughnhess(event.target.value);
  };

  return (
    <div className="type_list">
      <div className="list">
        {data?.map((element, index) => {
          return (
            <div key={index} className="single_select_subject">
              <input
                type="radio"
                id={index}
                value={element.Toughness}
                checked={element.Toughness == currentToughness}
                onChange={(event) => {
                  setCurrentToughnhess(event.target.value);
                }}
              />
              <label htmlFor={index}>{element.Toughness}</label>
            </div>
          );
        })}
      </div>

      {data
        ?.filter((element) => {
          if (element.Toughness == currentToughness) {
            return element;
          }
        })
        .map((element) => {
          return (
            <div className="progress_box_wrapper">
              <div className="progress_box">
                <div className="progress-circle">
                  <div className="progress-circle-top">
                    <div className="progress-circle-one">
                      <CircularProgressbar
                        styles={buildStyles({
                          textSize: "0.875rem",
                          pathColor: "#DF2727",
                          borderRadius: "50%",
                          width: "150",
                          backgroundColor: "#FFC2C2",
                          border: "6px solid #DF2727",
                        })}
                        className="circular"
                        sqSize="200"
                        value={element.WRONG}
                        text={`${element.WRONG} %
                  `}
                        strokeWidth={7}
                        background="#fff"
                      />

                      <span>Wrong</span>
                    </div>

                    <div className="progress-circle-two">
                      <CircularProgressbar
                        styles={buildStyles({
                          textSize: "0.875rem",
                          backgroundColor: "#D9D9D9",
                          pathColor: "#6A6A6A",
                        })}
                        className="circular"
                        value={element.Unattempted}
                        text={`${element.Unattempted} %`}
                        strokeWidth={7}
                        background="#ffffff"
                      />
                      <span>Unattempted</span>
                    </div>
                  </div>

                  <div className="progress-circle-bottom">
                    <div className="progress-circle-third">
                      <CircularProgressbar
                        styles={buildStyles({
                          textSize: "0.875rem",
                          backgroundColor: "#A5E9B8",

                          pathColor: "#00A02D",
                        })}
                        className="circular"
                        value={element.Correct}
                        text={`${element.Correct} %`}
                        strokeWidth={7}
                        background="#ffffff"
                      />
                      <span className="progress-circle-text">Correct</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}

      {/* {loader && <LoaderPopUp />} */}
    </div>
  );
};

export default OtsDifficultyLevelCircularProgress;
